(function(){
  /* -----------------------------------------------------------------
     24/08 : le pop-up "Derniere chance / moitie prix" avant paiement a
     ete supprime. Ce bloc ne garde que le controle de commande minimum.
     Aucun ecran bloquant entre le panier et le checkout.
  ----------------------------------------------------------------- */
  var MIN=3000;
  var proceedNow=false, cartTotal=0;

  function money(c){return (c/100).toFixed(2).replace('.',',')+' €';}
  function el(id){return document.getElementById(id);}

  function updateMinMsg(){
    var m=el('kinbo-min-msg');
    if(!m)return;
    if(cartTotal>0 && cartTotal<MIN){
      m.innerHTML='Commande minimum <strong>30&nbsp;€</strong> — il te manque <strong>'+money(MIN-cartTotal)+'</strong>';
      m.style.display='block';
    }else{ m.style.display='none'; }
  }

  function refreshCart(cb){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      cartTotal=c.total_price;
      updateMinMsg();
      if(cb)cb();
    }).catch(function(){if(cb)cb();});
  }

  function proceed(){
    proceedNow=true;
    var b=el('kinbo-checkout-btn');
    if(b){b.click();}else{window.location.href='/checkout';}
  }

  /* -----------------------------------------------------------------
     Stubs des anciens upsells (pop-up + order bump chaussettes).
     Les deux ont ete retires du tiroir le 24/08 : a 17 EUR l'ajout faisait
     franchir le seuil des 100 EUR, soit 9,99 EUR de port perdus et 15% de
     frais Corsopay pour un cout d'achat de 6,85 EUR, donc une marge de
     -0,89 EUR par vente. Ces fonctions vides evitent une erreur JS si un
     autre fichier les appelle encore.
  ----------------------------------------------------------------- */
  window.kinboOpenUpsell=function(){return false;};
  window.kinboCloseUpsell=function(){};
  window.kinboSkipUpsell=function(){proceed();};
  window.kinboAddUpsell=function(){proceed();};
  window.kinboBumpTap=function(){};
  window.kinboBumpSizeChange=function(){};

  function gate(e){
    var b = (e.target && e.target.closest) ? e.target.closest('#kinbo-checkout-btn') : null;
    if(!b) return;
    if(proceedNow) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    refreshCart(function(){
      if(cartTotal<MIN){ updateMinMsg(); return; }
      proceed();
    });
  }

  window.addEventListener('click', gate, true);
  document.addEventListener('click', gate, true);
  window.kinboRefreshMin=refreshCart;
  refreshCart();
  document.addEventListener('click',function(ev){
    var t=ev.target;
    if(t&&t.closest&&(t.closest('[data-cart-drawer-open]')||t.closest('a[href="/cart"]'))){setTimeout(refreshCart,700);}
  }, false);
})();

(function(){
  /* Masque l'ancien bloc #cart-upsell-wrap si des chaussettes sont deja
     au panier. Conserve tel quel : l'element n'existe plus dans le tiroir,
     ce garde-fou ne fait rien mais ne coute rien. */
  var SOCK_PIDS=[15614720999772,15677701259612,15677701226844];
  var sockInCart=false;
  function wrapEl(){return document.getElementById('cart-upsell-wrap');}
  function enforce(){var w=wrapEl();if(w&&sockInCart&&w.style.display!=='none'){w.style.display='none';}}
  function check(){return fetch('/cart.js').then(function(r){return r.json();}).then(function(c){sockInCart=(c.items||[]).some(function(i){return SOCK_PIDS.indexOf(i.product_id)!==-1;});enforce();}).catch(function(){});}
  function observe(){var w=wrapEl();if(!w||w.__kinboObs)return;w.__kinboObs=true;var mo=new MutationObserver(function(){enforce();});mo.observe(w,{attributes:true,attributeFilter:['style']});}
  function wrapFn(name){var o=window[name];if(typeof o==='function'&&!o.__kinboWrapped){var nf=function(){var r=o.apply(this,arguments);setTimeout(check,150);setTimeout(check,600);return r;};nf.__kinboWrapped=true;window[name]=nf;}}
  function init(){observe();if(wrapEl()){check();wrapFn('addUpsellToCart');wrapFn('updateQty');wrapFn('removeItem');wrapFn('openCartDrawer');wrapFn('loadCart');}}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
